import * as React from 'react';
import styles from './style.module.scss';
import { useSvgEditService } from '@/services/svg-edit-service';
import { Entry } from './context-menu-entry';

const Separator: React.FC = () => {
    return (
        <li className={styles.separator}></li>
    );
}

interface Position {
    x: number;
    y: number;
}

export const ContextMenu = () => {
    const svgEditService = useSvgEditService();

    const [visible, setVisible] = React.useState<boolean>(false);
    const [position, setPosition] = React.useState<Position>({ x: 0, y: 0});

    React.useEffect(() => {
        svgEditService.RegisterReadyEvent(() => {
            const workarea = svgEditService.editor.workarea;

            workarea.addEventListener("contextmenu", (ev) => {
                if (ev.ctrlKey && ev.shiftKey) { // Give us an escape route for easy inspect element and friends.
                    return;
                }

                ev.preventDefault();

                setVisible(true);
                setPosition({ x: ev.pageX, y: ev.pageY });
            });

            document.addEventListener("mousedown", () => {
                setVisible(false);
            })
        });
    }, []);


    const elements = svgEditService.selectedElements ?? [];
    const hasElementSelected = elements.length > 0;
    const hasMultipleSelected = elements.length > 1;
    const hasSingleGroupSelected = elements.length === 1 && elements[0].tagName.toLowerCase() === "g";

    const canPaste = svgEditService.canvas ? JSON.parse(sessionStorage.getItem(svgEditService.canvas.getClipboardID())) : false;

    const style: React.CSSProperties = {
        display: visible ? "block" : "none",
        left: `${position.x}px`,
        top: `${position.y}px`,
    };

    return (
        <ul className={styles.contextMenu} style={style} onMouseDown={e => e.stopPropagation()}>
            <Entry shortcutAlias="cut" disabled={!hasElementSelected}>Cut</Entry>
            <Entry shortcutAlias="copy" disabled={!hasElementSelected}>Copy</Entry>
            <Entry shortcutAlias="paste" disabled={!canPaste}>Paste</Entry>
            <Entry shortcutAlias="pasteinplace" disabled={!canPaste}>Paste in Place</Entry>
            <Separator />
            <Entry shortcutAlias="delete" disabled={!hasElementSelected}>Delete</Entry>
            <Separator />
            <Entry shortcutAlias="group" disabled={!hasMultipleSelected && !hasSingleGroupSelected}>{hasSingleGroupSelected ? 'Ungroup' : 'Group'}</Entry>
            <Separator />
            <Entry shortcutAlias="bringtofront" disabled={!hasElementSelected}>Bring to Front</Entry>
            <Entry shortcutAlias="bringforward" disabled={!hasElementSelected}>Bring Forward</Entry>
            <Entry shortcutAlias="pushbackward" disabled={!hasElementSelected}>Send Backward</Entry>
            <Entry shortcutAlias="pushtobottom" disabled={!hasElementSelected}>Send to Back</Entry>
            <Separator />
            <Entry onSelect={() => svgEditService.canvas.selectSame('fill')} disabled={!hasElementSelected}>Select Same Fill</Entry>
            <Entry onSelect={() => svgEditService.canvas.selectSame('stroke')} disabled={!hasElementSelected}>Select Same Stroke</Entry>
            <Entry onSelect={() => svgEditService.canvas.selectSame('appearance')} disabled={!hasElementSelected}>Select Same Appearance</Entry>
        </ul>
    );
}
